<template>
  <div class="pd-wrapper">
    <div class="pd-headWrapper">
      <div class="pd-titleWrapper">
        <button type="button" class="pd-button" @click="backPage">
          <BackArrowIcon />
        </button>
        <div class="pd-folderName">
          <p class="pd-projectTitle">{{ $t("textFolderDetails.folder") }}</p>
          {{ folderName }}
        </div>
        <v-dialog v-model="folderEditDialog" persistent max-width="500">
          <template v-slot:activator="{ on: dialog, attrs }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on: tooltip }">
                <div class="editFolderName" v-bind="attrs" v-on="{ ...dialog, ...tooltip }">
                  <EditIcon :width="19" :height="19" />
                </div>
              </template>
              <span>{{ $t("textFolderDetails.renameFolder") }}</span>
            </v-tooltip>
          </template>
          <v-card class="dialogWrapper">
            <div class="dialogTitleWrapper">
              <EditIcon />
              <div class="dialogTitle">
                {{ $t("textFolderDetails.dialogTitle") }}
              </div>
            </div>
            <div class="dialogWarn">
              {{ $t("textFolderDetails.dialogWarn") }}
            </div>
            <div class="createInputWrapper">
              <input type="text" autocomplete="off" :placeholder="$t('textFolderDetails.inputPlaceholder')"
                name="editName" v-model="editName" />
              <span v-if="inputError == true" class="fi-errorInput">{{
                  inputErrorText
              }}</span>
            </div>
            <div class="dialogActionWrapper">
              <v-btn color="darken-1" class="closeBtn" text @click="folderEditDialog = !folderEditDialog">{{
                  $t("textFolderDetails.closeBtn")
              }}</v-btn>
              <v-btn class="createBtn" text @click="editFolderName" :loading="folderLoading">{{
                  $t("textFolderDetails.changeBtn")
              }}</v-btn>
            </div>
          </v-card>
        </v-dialog>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <div style="
                display: flex;
                align-items: center;
                width: 19px;
                height: 19px;
                margin: 0 8px;
              " v-on="on" v-bind="attrs">
              <InfoIcon />
            </div>
          </template>
          <span>{{ $t("textFolderDetails.createdDate") }} {{ getFormatDate }}</span>
        </v-tooltip>
      </div>
      <v-btn class="pd-createAudiosButton" @click="clearState">
        <div style="margin-right: 10px">
          <MicIcon />
        </div>
        {{ $t("textFolderDetails.insertNewTextBtn") }}
      </v-btn>
    </div>
    <div v-if="infoLoading != true">
      <TextSynthesize v-if="focusedProjectIndex == null && infoLoading == false" ref="newSynthesize" :config="{
        inputText: config.inputText,
        voiceID: config.voiceID,
        selectedSpeed: config.selectedSpeed,
        background: config.background,
        pitch: config.pitch,
      }" :synthesize="textSynthesize" />

      <AudioDetails :key="adKey" v-else :audioInfo="audios[focusedProjectIndex]"
        :deleteAudioShowDialog="deleteAudioShowDialog" :setSettings="setSettingsAudio"
        :status="audios[focusedProjectIndex].status_new" :onEnd="onEnd" />
    </div>
    <div v-else class="pd-progressWrapper">
      <v-progress-circular :size="40" :width="3" color="#787ff7" indeterminate></v-progress-circular>
    </div>

    <div class="pd-audiosFullWrapper">
      <div class="pd-allAudiosPlayWrapper">
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="pd-allPlayButton" icon @click="playAll" v-on="on" v-bind="attrs">
              <PauseOutlineIcon color="#777FF6" :width="18" :height="18" v-if="allPlay" />

              <PlayOutlineIcon v-else />
            </v-btn>
          </template>
          <span v-if="allPlay"> {{ $t("textFolderDetails.allPlayStop") }}</span>
          <span v-else> {{ $t("textFolderDetails.allPlay") }}</span>
        </v-tooltip>
        <v-menu right min-width="230px" max-width="230px" offset-x>
          <template v-slot:activator="{ on: menu, attrs }">
            <v-tooltip right>
              <template v-slot:activator="{ on: tooltip }">
                <v-btn class="pd-allPlayButton" icon v-on="{ ...menu, ...tooltip }" v-bind="attrs">
                  <DownloadIcon width="18" height="18" color="#777FF6" />
                </v-btn>
              </template>
              <span>{{ $t("textFolderDetails.download") }}</span>
            </v-tooltip>
          </template>
          <v-list>
            <v-list-item-content class="align-center">
              <a :href="
                'https://reader.chimege.com/api/v2/group/' +
                folderId +
                '/download?type=archived&token=' +
                getToken
              " class="link" target="_self" :download="folderName" style="display: flex; text-decoration: none">
                <v-list-item class="fa-listItem" style="
                    padding-top: 10px !important;
                    padding-bottom: 10px !important;
                  ">
                  <div class="d-flex align-center justify-space-between" style="width: 100%">
                    <div class="d-flex flex-column">
                      <div class="fa-listTitle">
                        {{ $t("textFolderDetails.archive") }}
                      </div>
                      <div class="fa-listDesc">
                        {{ $t("textFolderDetails.listDesc1") }}
                      </div>
                    </div>
                    <div style="width: 16px; height: 16px; margin-left: 20px">
                      <DownloadIcon color="#767676" />
                    </div>
                  </div>
                </v-list-item>
              </a>
              <a :href="
                'https://reader.chimege.com/api/v2/group/' +
                folderId +
                '/download?type=merged&token=' +
                getToken
              " class="link" target="_self" :download="folderName" style="display: flex; text-decoration: none">
                <v-list-item style="
                    padding-top: 10px !important;
                    padding-bottom: 10px !important;
                  ">
                  <div class="d-flex align-center justify-space-between" style="width: 100%">
                    <div class="d-flex flex-column">
                      <div class="fa-listTitle">
                        {{ $t("textFolderDetails.export") }}
                      </div>
                      <div class="fa-listDesc">
                        {{ $t("textFolderDetails.listDesc2") }}
                      </div>
                    </div>
                    <div style="width: 16px; height: 16px; margin-left: 20px">
                      <DownloadIcon color="#767676" />
                    </div>
                  </div>
                </v-list-item>
              </a>
            </v-list-item-content>
          </v-list>
        </v-menu>
        <v-btn class="pd-allPlayButton d-sm-none" icon @click="clearState">
          <AddIcon color="#777FF6" />
        </v-btn>
      </div>
      <button class="pd-newSynthesizeButton" @click="clearState">
        <AddIcon />
        {{ $t("textFolderDetails.newText") }}
      </button>

      <div v-if="audiosLoading != true" class="pd-audiosWrapper">
        <vddl-list :list="audios" :horizontal="true" style="display: flex" :allowed-types="['itemType']"
          :external-sources="true">
          <vddl-draggable class="pd-audioWrapper" v-for="(item, index) in audios" :draggable="item" :key="item.id"
            :type="'itemType'" effect-allowed="copyMove" :index="index" :moved="handleMoved" :wrapper="audios">
            <AudioInfo :focus="
              focusedProjectIndex != null &&
                audios[focusedProjectIndex].id === item.id
                ? true
                : false
            " :projectId="item.id" :data="item" :name="item.name" :percent="item.percent" :status="item.status_new"
              :index="index" :deleteAudioShowDialog="deleteAudioShowDialog" :editAudioShowDialog="editAudioShowDialog"
              :showProjectInfo="getProjectInfo" :updatePercent="updatePercent" />
          </vddl-draggable>
        </vddl-list>
      </div>
      <div v-else class="pd-loadingLinear">
        <v-progress-linear color="#777ff6" indeterminate reverse></v-progress-linear>
      </div>
    </div>
    <v-dialog v-model="editDialog" persistent max-width="500">
      <v-card class="pd-dialogWrapper">
        <div class="pd-dialogTitleWrapper">
          <EditIcon />
          <div class="pd-dialogTitle">
            {{ $t("textFolderDetails.audioDialogTitle") }}
          </div>
        </div>
        <div class="pd-dialogWarn">
          {{ $t("textFolderDetails.audioDialogWarn") }}
        </div>
        <div class="pd-inputDialogWrapper">
          <input type="text" autocomplete="off" :placeholder="$t('textFolderDetails.audioPlaceholder')" name="editAudio"
            v-model="editName" />
          <span v-if="inputError == true" class="pd-errorInput">{{
              inputErrorText
          }}</span>
        </div>
        <div class="pd-dialogActionWrapper">
          <v-btn color="darken-1" class="pd-closeBtn" text @click="closeDialog">{{ $t("textFolderDetails.audioCloseBtn")
          }}</v-btn>
          <v-btn class="pd-changeBtn" text :loading="this.dialogLoading" @click="updateAudioName">{{
              $t("textFolderDetails.audioChangeBtn")
          }}</v-btn>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="removeDialog" persistent max-width="380">
      <v-card class="pd-dialogWrapper">
        <div class="pd-dialogRemoveTitleWrapper">
          <DeleteIcon />
          <div class="pd-dialogRemoveTitle">
            {{ $t("textFolderDetails.dialogRemoveTitle") }}
          </div>
        </div>
        <div class="pd-dialogRemoveQuestion">
          {{ $t("textFolderDetails.dialogRemoveQuestion") }}
        </div>
        <div class="pd-dialogActionWrapper">
          <v-btn color="darken-1" class="pd-closeBtn" text @click="closeDialog">{{
              $t("textFolderDetails.dialogCloseBtn")
          }}</v-btn>
          <v-btn class="pd-removeBtn" text @click="deleteAudio" :loading="dialogLoading">{{
              $t("textFolderDetails.dialogRemoveBtn")
          }}</v-btn>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="videoInsDialog" persistent max-width="800">
      <v-card class="pd-videoDialogWrapper">
        <!-- <video width="100%" controls>
          <source crossOrigin="anonymous" :src="video" type="video/mp4" />
          <source crossOrigin="anonymous" :src="video" type="video/ogg" />
          Your browser does not support HTML video.
        </video> -->
        <iframe width="100%" height="400px" src="https://www.youtube.com/embed/LY0lLcz3Qis" title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen></iframe>
        <div class="pd-dialogActionWrapper">
          <v-btn class="pd-closeBtn" text @click="videoInsDialog = false">{{
              $t("textFolderDetails.dialogActionWrapper")
          }}</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
// import AudioPlayerInfo from "../components/AudioPlayerInfo";
import { format } from "date-fns";
import AudioInfo from "../components/AudioInfo";
import TextSynthesize from "../components/TextSynthesize";
import AudioDetails from "../components/AudioDetails";
// icon
import InfoIcon from "../components/icons/InfoIcon";
import BackArrowIcon from "../components/icons/BackArrowIcon";
import MicIcon from "../components/icons/MicIcon";
import PlayOutlineIcon from "../components/icons/PlayOutlineIcon";
import DownloadIcon from "../components/icons/DownloadIcon";
import AddIcon from "../components/icons/AddIcon";
import DeleteIcon from "../components/icons/DeleteIcon";
import EditIcon from "../components/icons/EditIcon";
import PauseOutlineIcon from "../components/icons/PauseOutlineIcon";
import { mapActions, mapState } from "vuex";
var arraysMatch = function (arr1, arr2) {
  if (arr1.length !== arr2.length) return false;
  for (var i = 0; i < arr1.length; i++) {
    if (arr1[i].id !== arr2[i].id) return false;
  }
  return true;
};
export default {
  name: "textFolderDetails",
  components: {
    AudioInfo,
    InfoIcon,
    BackArrowIcon,
    MicIcon,
    PlayOutlineIcon,
    DeleteIcon,
    AddIcon,
    TextSynthesize,
    AudioDetails,
    EditIcon,
    PauseOutlineIcon,
    DownloadIcon,
  },
  data: () => ({
    folderName: "",
    clientKey: "",
    folderId: 0,
    folderCreatedDate: null,
    token: null,
    audios: [],
    oldAudios: [],
    partAudios: [],
    count: 0,
    page: 1,
    pageCount: 0,
    adKey: 0,
    itemsPerPage: 1000,
    focusedProjectIndex: null,
    infoLoading: false,
    convertLoading: false,
    audiosLoading: true,
    dialogLoading: false,
    folderLoading: false,
    balance: null,
    editName: "",
    removeDialog: false,
    editDialog: false,
    folderEditDialog: false,
    videoInsDialog: false,
    inputError: false,
    inputErrorText: "",
    editAudioId: null,
    editAudioIndex: null,
    currentPlayingAudioIndex: null,
    config: {
      inputText: "",
      voiceID: "FEMALE3v2",
      selectedSpeed: 1,
      pitch: 1,
      background: "none",
    },
    video: "https://www.youtube.com/watch?v=LY0lLcz3Qis&t=2s",
  }),
  created() {
    this.folderId = this.$route.params.folderId;
  },
  destroyed() {
    this.stopAllPlay();
  },
  computed: {
    ...mapState(["allPlay", "currentAudioId", "audioInfo"]),

    getCurrentProject: function () {
      return this.audios[this.focusedProjectIndex];
    },
    getToken: function () {
      return this.$cookie.get("token");
    },
    getFormatDate: function () {
      var currentDate = new Date(this.folderCreatedDate);
      currentDate.setHours(currentDate.getHours());
      return format(currentDate, "yyyy/MM/dd HH:mm");
    },
    ids: function () {
      let list = [];
      for (let i = 0; i < this.audios.length; i++) {
        list.push(this.audios[i].id);
      }
      return list;
    },
  },
  watch: {
    editName: function () {
      this.inputValidate();
    },
    currentAudioId: function () {
      if (this.currentAudioId === null) {
        this.currentPlayingAudioIndex = null;
      }
    },
    folderEditDialog: function () {
      if (this.folderEditDialog) {
        this.editName = this.folderName;
      }
    },
    audioInfo: function () {
      this.audios.forEach((audio, index) => {
        if (audio.id === this.audioInfo.oldProjectId) {
          this.audios[index].percent = this.audioInfo.percent;
          if (this.audioInfo.projectStatus === "synthesized") {
            this.getProjectInfo(this.audioInfo.oldProjectId, index);
          }
        }
      });
    },
  },
  mounted() {
    this.getAudioList();
  },
  methods: {
    ...mapActions([
      "playAllPlay",
      "pauseAllPlay",
      "stopAllPlay",
      "pause",
      "updateUser",
      "changeCurrentId",
      "initProjects",
      "showWarningMessage",
      "showSuccessMessage",
      "showErrorMessage",
      "checkError",
      "updateBalance",
    ]),
    playAll() {
      if (this.allPlay) {
        this.pauseAllPlay();
        this.pause();
      } else {
        this.playAllPlay();
        if (this.currentAudioId === null) {
          this.nextAudio();
        }
      }
    },
    onEnd() {
      if (this.allPlay) {
        this.nextAudio();
      }
    },
    updateAudioDetailKey() {
      this.adKey++;
    },
    nextAudio() {
      if (this.currentPlayingAudioIndex === null) {
        this.currentPlayingAudioIndex = 0;
      } else {
        this.currentPlayingAudioIndex += 1;
        if (this.currentPlayingAudioIndex > this.audios.length - 1) {
          this.stopAllPlay();
          this.currentPlayingAudioIndex = null;
          return;
        }
      }

      for (
        let index = this.currentPlayingAudioIndex;
        index < this.audios.length;
        index++
      ) {
        const element = this.audios[index];
        if (element.percent === 100) {
          this.currentPlayingAudioIndex = index;
          this.changeCurrentId(element.id);
          this.getProjectInfo(element.id, index);
          break;
        }
        if (index === this.audios.length - 1) {
          this.currentPlayingAudioIndex = null;
          this.stopAllPlay();
        }
      }
    },
    handleMoved(item) {
      const { index, list } = item;
      list.splice(index, 1);
      if (!arraysMatch(list, this.oldAudios)) {
        this.changeOrder(this.ids);
        this.oldAudios = [...this.audios];
      }
    },
    changeOrder(list) {
      let headers = {
        type: "application/json",
        token: this.getToken,
      };
      let body = list;
      axios
        .post(`${process.env.VUE_APP_BASE_URL}/v2/changeOrder`, body, {
          headers,
        })
        .then((res) => {
          if (res.status == 200) {
            this.showSuccessMessage({
              message: this.$t("textFolderDetails.sucessMsg2"),
              timeout: 3000,
            });
          }
        })
        .catch((error) => {
          this.checkError(error);
        });
    },
    /*  Хөрвүүлэгдсэн байгаа бүх аудио бичлэгийн листийг харуулах функц */
    getAudioList() {
      const headers = {
        token: this.getToken,
      };
      axios
        .get(
          `${process.env.VUE_APP_BASE_URL}/v2/group/${this.folderId}?page=${this.page}&per_page=${this.itemsPerPage}`,
          {
            headers,
          }
        )
        .then((response) => {
          this.folderName = response.data.data.name;
          this.folderCreatedDate = response.data.data.created_date;
          if (response.data.data.projects != null) {
            this.audios = response.data.data.projects;
            if (this.audios[0].order_id === 0) {
              this.changeOrder(this.ids);
            }
          }
          this.audiosLoading = false;
        })
        .catch((error) => {
          this.audiosLoading = false;
          this.checkError(error);
        });
    },

    nextPage(page) {
      this.page = page;
      this.getAudioList();
    },
    backPage() {
      this.$router.go(-1);
    },
    editFolderName() {
      if (this.inputError != true) {
        const headers = {
          token: this.getToken,
        };
        this.folderLoading = true;
        axios
          .put(
            `${process.env.VUE_APP_BASE_URL}/v2/group/${this.folderId}/name`,
            this.editName,
            { headers }
          )
          .then((response) => {
            if (response.status === 200) {
              this.showSuccessMessage({
                message: this.$t("textFolderDetails.successMsg1"),
                timeout: 3000,
              });
              this.folderName = this.editName;
            }
            this.folderLoading = false;
            this.folderEditDialog = false;
          })
          .catch((error) => {
            this.folderLoading = false;
            this.folderEditDialog = false;
            this.checkError(error);
          });
      }
    },

    /* Бичсэн бичвэрийг аудио бичвэр рүү буулгах хүсэлтийн функц */
    textSynthesize(text, voiceID, voiceSpeed, background, pitch) {
      if (text !== "") {
        var headers = {
          type: "text/plain",
          token: this.getToken,
        };
        axios
          .post(
            `${process.env.VUE_APP_BASE_URL}/v2/synthesize/` +
            this.folderId +
            "?voiceID=" +
            voiceID +
            "&speed=" +
            voiceSpeed +
            "&background=" +
            background +
            "&pitch=" +
            pitch +
            `&type=text`,
            text,
            { headers }
          )
          .then((res) => {
            if (res.status == 200) {
              this.$refs.newSynthesize.loading = false;
              this.updateUser(this.getToken);
              var currentAudios = [...this.audios, res.data.data];
              this.audios = [];
              this.audios = currentAudios;
              this.changeOrder(this.ids);
              this.changeDesc(res.data.data.Percent);
              this.$nextTick(function () {
                document
                  .getElementById(res.data.data.id.toString())
                  .scrollIntoView();
                this.focusedProjectIndex = this.audios.length - 1;
              });
              this.updateBalance(this.getToken);
            }
          })
          .catch((error) => {
            this.$refs.newSynthesize.loading = false;
            this.checkError(error);
          });
      } else {
        this.showWarningMessage({
          message: this.$t("textFolderDetails.warningMsg1"),
          timeout: 3000,
        });
        this.$refs.newSynthesize.loading = false;
      }
    },

    /* Хөрвүүлэгдсэн аудиог устгах функц*/
    deleteAudio() {
      this.dialogLoading = true;
      var headers = { token: this.getToken };
      axios
        .delete(
          `${process.env.VUE_APP_BASE_URL}/deleteproject/${this.editAudioId}`,
          {
            headers: headers,
          }
        )
        .then((res) => {
          if (res.status == 200) {
            this.showSuccessMessage({
              message: this.$t("textFolderDetails.successMsg3"),
              timeout: 3000,
            });
            if (
              this.focusedProjectIndex != null &&
              this.audios[this.focusedProjectIndex].id == this.editAudioId
            ) {
              this.clearState();
            }
            this.audios = this.audios.filter(
              (audio) => audio.id !== this.editAudioId
            );
            this.closeDialog();
          }
        })
        .catch((error) => {
          this.dialogLoading = false;
          this.checkError(error);
        });
    },
    /* Аудионы устгахын тулд диалог гаргах функц*/
    deleteAudioShowDialog(projectId) {
      this.editAudioId = projectId;
      this.removeDialog = true;
    },

    /* Аудионы нэрийг солихийн тулд диалог гаргах функц*/
    editAudioShowDialog(projectId, index) {
      this.editAudioId = projectId;
      this.editAudioIndex = index;
      this.editName = this.audios[index].name;
      this.editDialog = true;
    },

    updateAudioName() {
      if (this.inputError != true) {
        this.dialogLoading = true;
        const headers = { token: this.getToken };
        axios
          .post(
            `${process.env.VUE_APP_BASE_URL}/updateprojectname/${this.editAudioId}`,
            this.editName,
            { headers }
          )
          .then((response) => {
            if (response.status == 200) {
              this.audios[this.editAudioIndex].name = this.editName;
              if (this.editAudioIndex === this.focusedProjectIndex) {
                this.updateAudioDetailKey();
              }
              this.showSuccessMessage({
                message: this.$t("textFolderDetails.successMsg4"),
                timeout: 3000,
              });
              this.closeDialog();
            }
          })
          .catch((error) => {
            this.dialogLoading = false;
            this.this.checkError(error);
          });
      }
    },

    /* Хөрвүүлсэн аудионы текстийн харах,Тухайн аудио төслийн бүх мэдээллийг харуулна*/
    getProjectInfo(projectId, index) {
      if (
        this.audios[index].text === "" ||
        this.audios[index].audio_path === "-"
      ) {
        const headers = { token: this.getToken };
        this.infoLoading = true;
        axios
          .get(`${process.env.VUE_APP_BASE_URL}/v2/project/` + projectId, {
            headers,
          })
          .then((response) => {
            this.infoLoading = false;
            this.audios[index] = response.data.data;
            this.focusedProjectIndex = index;
            this.updateAudioDetailKey();
          })
          .catch((error) => {
            this.infoLoading = false;
            this.checkError(error);
          });
      } else {
        this.focusedProjectIndex = index;
        this.updateAudioDetailKey();
      }
    },

    /* Бичлэгүүдийн мэдээллийг өөрчлөх */
    updatePercent(index, percent) {
      this.audios[index].percent = percent;
      if (index === this.focusedProjectIndex) {
        if (percent == 100) {
          this.getProjectInfo(this.audios[index].id, index);
        }
      }
      // }
    },
    watchVideo() {
      this.videoInsDialog = true;
    },

    /* Хөвүүлэгдэж буй хэсгүүдийн бичлэгийг харуулах */
    getPartAudios(projectId) {
      const headers = { token: this.getToken };
      this.axios
        .get(`${process.env.VUE_APP_BASE_URL}/getprojectparts/` + projectId, {
          headers,
        })
        .then((response) => {
          this.partAudios = response.data.data.List;
          this.infoLoading = false;
        })
        .catch((error) => {
          this.checkError(error);
        });
    },
    /**Хэрэглэгчийн багцын мэдээлэл */
    getUserInfo() {
      const headers = {
        token: this.getToken,
      };
      axios
        .get(`${process.env.VUE_APP_BASE_URL}/getuserinfo`, {
          headers,
        })
        .then((response) => {
          this.balance = response.data.data.Balance;
        })
        .catch((error) => {
          this.checkError(error);
        });
    },

    /* Шинэ бичвэр оруулахад оролтын мэдээллүүдийг цэвэрлэх функц*/
    clearState() {
      // this.$refs.newSynthesize.input.focus();
      this.config = {
        inputText: "",
        voiceID: "FEMALE3v2",
        selectedSpeed: 1,
        background: "none",
        pitch: 1,
      };
      this.infoLoading = false;
      this.focusedProjectIndex = null;
      this.$nextTick(function () {
        document.getElementById("textInput").focus();
      });
    },

    /* Засварлах функц*/
    setSettingsAudio(settings) {
      this.config = {
        inputText: settings.text,
        voiceID: settings.voiceId,
        selectedSpeed: settings.speed,
        background: settings.background,
        pitch: settings.pitch,
      };
      this.infoLoading = false;
      this.focusedProjectIndex = null;
      // this.inputValue = text;
    },
    changeDesc(percent) {
      if (percent == 100) {
        this.showSuccessMessage({
          message: this.$t("textFolderDetails.successMsg5"),
          timeout: 3000,
        });
      } else {
        this.showSuccessMessage({
          message: this.$t("textFolderDetails.successMsg6"),
          timeout: 3000,
        });
      }
    },

    /* Диалог хаах функц */
    closeDialog() {
      this.editName = "";
      this.inputError = false;
      this.editDialog = false;
      this.removeDialog = false;
      this.dialogLoading = false;
    },

    /* Тухайн эдитор дээр оруулсан зүйлүүдийг шалгах функц */
    inputValidate() {
      if (this.editName.length == 0) {
        this.inputErrorText = this.$t("textFolderDetails.inputValidator");
        this.inputError = true;
      } else if (this.editName.length > 21) {
        this.inputErrorText = this.$t("textFolderDetails.characterValidator");
        this.inputError = true;
      } else {
        this.inputError = false;
      }
    },
  },
};
</script>
<style scoped>
.pd-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
  padding-bottom: 180px;
  height: auto;
  position: relative;
}

.pd-audiosFullWrapper {
  display: flex;
  width: 241px;
  position: fixed;
  height: 162px;
  background-color: #fafafa;
  bottom: 48px;
  left: 76px;
  width: 100%;
  align-items: center;
}

.pd-allAudiosPlayWrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0px 16px;
}

.pd-allPlayButton {
  background-color: #eff0fd !important;
  border-radius: 50px;
  box-shadow: none;
  outline: none;
  height: 38px !important;
  width: 38px !important;
  margin-bottom: 10px;
}

.pd-newSynthesizeButton {
  display: flex;
  flex-direction: column;
  width: 119px;
  height: 110px;
  border: 2px dashed #e5e5e5;
  border-radius: 7px;
  margin-right: 16px;
  align-items: center;
  font-size: 12px;
  font-weight: 500;
  color: #98a7ad;
  justify-content: center;
  transition: all 0.3s;
}

.pd-newSynthesizeButton:hover {
  background-color: #e5e5e5;
  border: none;
  transition: all 0.3s;
}

.pd-audiosWrapper {
  display: flex;
  width: calc(100% - 265px);
  overflow-x: scroll;
}

.pd-audioWrapper {
  margin: 20px 10px 10px 0;
  border-radius: 7px;
}

.pd-audiosWrapper::-webkit-scrollbar {
  -webkit-appearance: none;
  height: 8px;
}

.pd-audiosWrapper::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.5);
  box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}

.pd-headWrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.pd-titleWrapper {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.pd-projectTitle {
  display: inline;
  font-size: 14px;
  font-weight: 700;
  color: #767676;
  margin: 0 5px;
}

.pd-folderName {
  height: auto;
  font-size: 20px;
  font-weight: 700;
  color: #231f20;
}

.pd-button {
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none !important;
  width: 30px;
  height: 30px;
  border-radius: 6px;
  transition: all 0.5s;
}

.pd-button:hover {
  background-color: #f5f5f5;
  transition: all 0.5s;
}

.pd-createAudiosButton {
  background-color: #ffffff !important;
  text-transform: initial;
  color: #767676;
  border: 2px solid #e5e5e5;
  border-radius: 6px;
  box-shadow: none;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  outline: none;
  margin-bottom: 10px;
  height: 40px !important;
  width: 200px;
  letter-spacing: 0;
}

.pd-synthesizeButton {
  background-color: #777ff6 !important;
  text-transform: initial;
  color: #ffffff;
  border-radius: 6px;
  box-shadow: none;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  outline: none;
  height: 40px !important;
  letter-spacing: 0;
}

.pd-subTitle {
  font-size: 14px;
  font-weight: 700;
  color: #767676;
  margin-bottom: 10px;
}

.pd-synthesizeWrapper {
  display: flex;
}

.pd-textShowWrapper {
  margin-top: 56px;
  width: 60%;
  padding: 16px;
  height: 352px;
  border-radius: 6px;
  border: 1px solid #e5e5e5;
  overflow-y: scroll;
}

.pd-textShowWrapper::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 8px;
}

.pd-textShowWrapper::-webkit-scrollbar-thumb {
  border-radius: 6px;
  background-color: rgba(0, 0, 0, 0.5);
  box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}

.pd-settingsWrapper {
  width: calc(40% - 40px);
  margin-left: 40px;
}

.pd-settingsTitleWrapper {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 10px;
}

.pd-toolsWrapper {
  width: fit-content;
  display: flex;
  flex-direction: column;
  padding: 16px;
  height: 300px;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  justify-content: space-between;
}

.pd-checkBoxTitle,
.pd-soundSpeed {
  font-weight: 500;
  font-size: 14px;
  color: #231f20;
  margin-bottom: 8px;
}

.pd-playButton {
  display: flex;
  height: 16px;
  margin-left: 10px;
  cursor: pointer;
}

.pd-progressWrapper {
  width: 100%;
  height: 50vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

@media screen and (max-width: 930px) {
  .pd-synthesizeWrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .pd-settingsWrapper {
    width: 100%;
    margin: 0;
  }

  .pd-toolsWrapper {
    height: auto;
  }
}

@media screen and (max-width: 599px) {
  .pd-headWrapper {
    justify-content: center;
  }

  .pd-subTitle {
    display: flex;
    justify-content: center;
  }

  .pd-fileInput {
    width: 250px;
  }

  .pd-newSynthesizeButton {
    display: none;
  }

  .pd-audiosFullWrapper {
    left: 0;
  }

  .pd-audiosWrapper {
    width: calc(100% - 70px);
  }
}

/* Диалог хэлбэржүүлэлтүүд */
.pd-dialogWrapper {
  padding: 31px 38px;
}

.pd-videoDialogWrapper {
  display: flex;
  flex-direction: column;
  padding: 10px;
  align-items: center;
}

@media screen and (max-width: 768px) {
  .pd-dialogWrapper {
    padding: 20px;
  }
}

.pd-dialogTitleWrapper {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
}

.pd-dialogTitle {
  font-size: 14px;
  font-weight: 500;
  color: #000000;
  margin-left: 5px;
}

.pd-dialogWarn {
  font-size: 14px;
  font-weight: 500;
  color: #767676;
  margin-bottom: 10px;
}

.pd-inputDialogWrapper {
  display: flex;
  flex-direction: column;
  position: relative;
  height: 56px;
}

.pd-inputDialogWrapper input[type="text"] {
  height: 40px !important;
  padding-left: 15px;
  padding-right: 15px;
  font-size: 14px;
  font-weight: 400;
  border: 2px solid #e5e5e5;
  border-radius: 6px;
  float: left;
  width: 100%;
  background-color: #ffffff;
  line-height: 16px;
  transition: 0.4s ease-out;
}

.pd-inputDialogWrapper input[type="text"]:focus {
  border: 2px solid #777ff6 !important;
  outline: none;
}

.pd-inputDialogWrapper input[type="text"]:hover {
  border: 2px solid #777ff6 !important;
  transition: 0.4s ease-out;
  outline: none;
}

.pd-errorInput {
  font-size: 12px;
  line-height: 14px;
  color: red;
  margin: 2px 0 0 10px;
}

.pd-dialogActionWrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}

.pd-closeBtn {
  background-color: #ffffff !important;
  text-transform: initial;
  color: #767676 !important;
  border: 2px solid #e5e5e5;
  border-radius: 6px;
  box-shadow: none;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  outline: none;
  margin-right: 15px;
  height: 34px !important;
  width: 64px !important;
}

.pd-changeBtn {
  background-color: #777ff6 !important;
  text-transform: initial;
  color: #ffffff !important;
  border-radius: 6px;
  box-shadow: none;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  outline: none;
  margin-right: 5px;
  height: 34px !important;
  width: 64px !important;
}

.pd-dialogRemoveTitleWrapper {
  display: flex;
  align-items: center;
  margin-bottom: 25px;
  color: #d23636;
}

.pd-dialogRemoveTitle {
  font-size: 16px;
  font-weight: 500;
  color: #d23636;
  margin-left: 10px;
  line-height: 18px;
}

.pd-dialogRemoveQuestion {
  font-size: 14px;
  line-height: 16px;
  color: #767676;
}

.pd-removeBtn {
  background-color: #d23636 !important;
  text-transform: initial;
  color: #ffffff !important;
  border-radius: 6px;
  box-shadow: none;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  outline: none;
  margin-right: 5px;
  height: 34px !important;
  width: 64px !important;
}

.pd-loadingLinear {
  display: flex;
  align-items: top;
  width: calc(100% - 265px);
  justify-content: flex-start;
  height: 110px;
}

.editFolderName {
  height: 19px;
  margin-left: 8px;
}

.fa-listDesc {
  font-size: 12px;
  line-height: 14px;
  color: #767676;
}

.fa-listItem {
  border-bottom: 1px solid #e5e5e5;
}

.fa-listTitle {
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  color: #231f20;
  margin-bottom: 4px;
}
</style>
